"use strict";
/**
 * Entity Type Enums
 *
 * Represents the various entity types used across the application.
 * Different contexts use different subsets of entity types.
 *
 * Consumers: lambda-main, lambda-secure, lambda-utilities, free-pattern-warehouse-website
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlagContentType = exports.ModerationQueueCategory = exports.ModerationItemType = void 0;
/**
 * Moderation Item Type
 *
 * Discriminator values for the ModerationItem discriminated union.
 * Used in moderation-unified.ts for type-safe moderation item handling.
 */
var ModerationItemType;
(function (ModerationItemType) {
    ModerationItemType["PATTERN"] = "pattern";
    ModerationItemType["REVIEW"] = "review";
    ModerationItemType["MATERIAL"] = "material";
    ModerationItemType["COMMENT"] = "comment";
    ModerationItemType["CRAFT_ROOM"] = "craft_room";
    ModerationItemType["PROFILE"] = "profile";
})(ModerationItemType || (exports.ModerationItemType = ModerationItemType = {}));
/**
 * Moderation Queue Category
 *
 * Categories used to filter the moderation queue.
 * Matches ModerationItemType values — kept as a separate enum
 * for semantic clarity in queue filtering contexts.
 */
var ModerationQueueCategory;
(function (ModerationQueueCategory) {
    ModerationQueueCategory["PATTERN"] = "pattern";
    ModerationQueueCategory["REVIEW"] = "review";
    ModerationQueueCategory["MATERIAL"] = "material";
    ModerationQueueCategory["COMMENT"] = "comment";
    ModerationQueueCategory["CRAFT_ROOM"] = "craft_room";
    ModerationQueueCategory["PROFILE"] = "profile";
})(ModerationQueueCategory || (exports.ModerationQueueCategory = ModerationQueueCategory = {}));
/**
 * Flag Content Type
 *
 * Entity types that can be flagged by users.
 * Used in the unified flagging system.
 */
var FlagContentType;
(function (FlagContentType) {
    FlagContentType["REVIEW"] = "review";
    FlagContentType["COMMENT"] = "comment";
    FlagContentType["PATTERN"] = "pattern";
    FlagContentType["PROJECT"] = "project";
    FlagContentType["MATERIAL"] = "material";
    FlagContentType["PROFILE"] = "profile";
})(FlagContentType || (exports.FlagContentType = FlagContentType = {}));
